import React from "react";

interface RoleCellProps {
  role?: string;
}

export const RoleCell: React.FC<RoleCellProps> = ({ role = "Staff" }) => {
  return <span>{role}</span>;
};
